import React from 'react';
import InputField from '../../../Forms/Input/InputField';

interface CreditAmountSectionProps {
  creditAmount: number | '';
  onChange: (value: number | '') => void;
}

const CreditAmountSection: React.FC<CreditAmountSectionProps> = ({
  creditAmount,
  onChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '') {
      onChange('');
    } else {
      const parsed = Number(value);
      if (!isNaN(parsed) && parsed >= 0) {
        onChange(parsed);
      }
    }
  };

  return (
    <>
      <p className="text-gray-600 dark:text-gray-400 text-sm">
        Ingresa el monto total autorizado para esta venta a crédito.
      </p>
      <div className="grid gap-4 sm:grid-cols-2">
        <InputField
          label="Monto de Crédito Autorizado"
          name="creditAmount"
          iconKey="dollar"
          type="number"
          value={creditAmount}
          onChange={handleChange}
          min={0}
        />
      </div>
    </>
  );
};

export default CreditAmountSection;
